import type { ReactNode } from "react";

import type { BillingConfigPrice } from "../../types";

interface PriceDisplayProps {
  price: BillingConfigPrice;
  hideDescription?: boolean;
}

export function PriceDisplay({
  price,
  hideDescription,
}: PriceDisplayProps): ReactNode {
  return (
    <div className="flex flex-col">
      <div className="flex items-baseline justify-between">
        <div className="font-heading font-semibold text-r8-xl break-anywhere text-r8-gray-12">
          {price.price}
        </div>
      </div>

      <div className="space-y-1">
        <p className="text-r8-sm text-r8-gray-11 group-hover:text-r8-gray-12 transition-colors">
          {price.title}
        </p>
        {!hideDescription && price.description && (
          <p className="text-r8-xs text-r8-gray-10 group-hover:text-r8-gray-12 transition-colors">
            {price.description}
          </p>
        )}
      </div>
    </div>
  );
}
